<template>
	<div class="assets">
		<ul class="file_body">
			<li tabindex="0" class="file_item" v-for="file in value">
				<div v-if="file.url" class="file">
					<img :src="file.url" alt="" class="img" v-if="file.type == 'image'" />
					<img
						src="~@/assets/richText/video.png"
						alt=""
						class="video"
						v-if="file.type == 'video'"
					/>
				</div>
				<i class="el-icon-upload" v-if="!file.url"></i>
				<div class="controls" v-if="!disabled">
					<i class="el-icon-zoom-in" v-if="file.type == 'image'" @click="viewFile(file)"></i>
					<i class="el-icon-video-play" v-if="file.type == 'video'" @click="viewFile(file)"></i>
					<i class="el-icon-delete" @click="deleteFile(file)"></i>
				</div>
				<el-progress
					:percentage="file.percentage"
					:show-text="false"
					v-if="file.percentage && file.percentage != 100"
				></el-progress>
			</li>
		</ul>

		<el-dialog :visible.sync="dialogVisible" :append-to-body="true">
			<img width="100%" :src="dialogUrl" alt="" v-if="type == 'image'" />
			<video width="100%" height="500px" :src="dialogUrl" v-if="type == 'video'" controls></video>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'assets',
	props: ['value', 'disabled'],
	data() {
		return {
			dialogVisible: false,
			dialogUrl: '',
			type: 'image',
		};
	},
	methods: {
		// 查看
		viewFile(file) {
			let { type, url } = file;
			this.dialogUrl = url;
			this.type = type;
			this.dialogVisible = true;
		},
		// 删除
		deleteFile(file) {
			let { ossName } = file;
			let index = this.value.findIndex(e => {
				return e.ossName == ossName;
			});
			if (file.client) file.client.cancel();
			this.value.splice(index, 1);
			this.$emit('input', this.value);
		},
	},
};
</script>

<style lang="scss" scoped>
.assets {
	.file_body {
		margin: 0;
		display: inline;
		vertical-align: top;
		padding: 0;
		list-style: none;

		.file_item {
			width: 80px;
			height: 80px;
			text-align: center;
			background-color: #f2f2f2;
			overflow: hidden;
			border: 1px solid #c0ccda;
			border-radius: 6px;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
			margin: 0 8px 8px 0;
			display: inline-block;
			-webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
			transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
			font-size: 14px;
			color: #606266;
			line-height: 1.8;
			position: relative;

			.file {
				width: 100%;
				height: 100%;

				img {
					width: 100%;
					height: 100%;
				}

				.video {
					width: 80%;
					height: 80%;
					position: absolute;
					top: 0;
					left: 0;
					bottom: 0;
					right: 0;
					margin: auto;
				}
			}

			::v-deep  .el-progress {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				display: flex;
				flex-direction: column-reverse;
			}

			.el-icon-upload {
				font-size: 30px;
				height: 30px;
				width: 30px;
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				margin: auto;
			}

			.controls {
				position: absolute;
				width: 100%;
				height: 100%;
				left: 0;
				top: 0;
				cursor: default;
				text-align: center;
				color: #fff;
				opacity: 0;
				font-size: 20px;
				background-color: rgba(0, 0, 0, 0.5);
				transition: opacity 0.3s;
				display: flex;
				justify-content: space-evenly;
				align-items: center;

				i {
					cursor: pointer;
				}
			}

			.controls:hover {
				opacity: 1;
			}
		}
	}
}
</style>
